/** W3 image widget (PMA-BCAST-013): library asset by id, fit contain|cover. */
export interface ImageWidgetOptions {
  asset_id?: string;
  fit?: "contain" | "cover";
}

export function ImageWidget({
  options,
  assets,
}: {
  options: Record<string, unknown>;
  assets: Record<string, string>;
}) {
  const id = typeof options.asset_id === "string" ? options.asset_id : "";
  const url = id ? assets[id] : undefined;
  const fit = options.fit === "cover" ? "cover" : "contain";
  if (!url)
    return (
      <div
        data-testid="broadcast-image-empty"
        style={{ width: "100%", height: "100%" }}
      />
    );
  return (
    <img
      data-testid="broadcast-image"
      data-fit={fit}
      src={url}
      alt=""
      draggable={false}
      style={{
        width: "100%",
        height: "100%",
        objectFit: fit,
        display: "block",
      }}
    />
  );
}
